<template>
  <div class="asc-analytic-watchlist-grid">
    <asc-grid-wrapper-header>
      <asc-accent-button
        button-text="Export"
        :on-click="handleExportGrid"
      ></asc-accent-button>
    </asc-grid-wrapper-header>
    <asc-ag-grid-filter
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscAgGridAutocompleteFloatFilter,
  AscAgGridDateFloatFilter,
  AscSparklineCellRenderer,
  AscTooltipCellRenderer,
} from '@/components/agGrid'
import AscGridWrapperHeader from './AscGridWrapperHeader'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import { getFormattedDateTime } from '@/utilities/dates'
import { isInternetExplorer } from '@/utilities/browser'
import {
  stringTextMatcher,
  dateStringMatcher,
} from '@/components/agGrid/AgGridHelperMethods'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscAnalyticWatchlistGrid',

  components: {
    AscAgGridFilter,
    AscGridWrapperHeader,
    AscAccentButton,
    AscAgGridAutocompleteFloatFilter,
    AscAgGridDateFloatFilter,
    AscSparklineCellRenderer,
    AscTooltipCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        rowSelection: 'single',
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'Tail',
          field: 'tailNumber',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('tailNumber'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Component',
          field: 'component',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('component'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Analytic',
          field: 'analytic',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('analytic'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Last Updated Date',
          field: 'mostRecentFlight',
          width: 155,
          minWidth: 155,
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: dateStringMatcher,
          },
          floatingFilterComponent: 'AscAgGridDateFloatFilter',
          floatingFilterComponentParams: {
            suppressFilterButton: true,
            items: this.values,
          },
          valueFormatter: data => getFormattedDateTime(data.value),
          comparator: this.sortDate,
        },
        {
          headerName: 'Health Index',
          field: 'riskScore',
          cellClass: 'ag-cell--center',
          sort: 'desc',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Fleet Average',
          field: 'fleetAverage',
          cellClass: 'ag-cell--center',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Aircraft Trend',
          field: 'aircraftTrend',
          cellRenderer: 'AscSparklineCellRenderer',
          minWidth: 140,
          maxWidth: 140,
          width: 140,
          hide: isInternetExplorer(),
        },
      ]
    },
  },

  watch: {
    values() {
      this.handleRefreshColWidths()
    },
  },

  methods: {
    handleExportGrid() {
      this.agGridOptions.api.exportDataAsCsv()
    },
    handleCellClicked(event) {
      if (event) {
        const field = event.colDef.field
        if (field !== 'aircraftTrend') {
          this.onOpen(event.data)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-sort-icon {
  color: $primary_black;
  position: absolute;
  top: 14px;
  right: 16px;
}

.asc-filter-icon {
  color: $primary_black;
}
</style>
